import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '45px',
  },
  dividerStyles: {
    margin: '20px 0',
  },
  loadingStyles: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rowWrapped: {
    display: 'flex',
    backgroundColor: '#ffffff',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '16px',
    marginBottom: '16px',
  },
  bookingType: {
    backgroundColor: '#ffffff',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '16px',
    marginBottom: '16px',
  },
  infoWrapped: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '16px',
  },
  fontBolded: {
    fontWeight: 600,
  },
  captionText: {
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0',
  },
  lighterText: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '14px',
  },
  warningBox: {
    padding: '20px',
    background:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3;',
    borderRadius: '4px',
    margin: '20px 0',
    '& svg': {
      fill: theme.palette.primary.light,
    },
  },
  learnMoreText: {
    color: '#00234B',
    fontWeight: '600',
    cursor: 'pointer',
  },
  iconStyled: {
    backgroundColor: 'rgba(0, 35, 75, 0.08)',
    height: '40px',
    width: '40px',
  },

  coachCardWrapper: {
    margintop: '25px',
  },
  sectionTitle: {
    marginBottom: '20px',
  },
  textWrapped: {
    display: 'flex',
    flexDirection: 'column',
  },

  signInText: {
    marginTop: '10px',
    alignSelf: 'center',
  },

  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  chip: {
    color: '#fff',
    borderRadius: '4px',
    height: '22px',
    fontSize: '10px',
  },
  chipInfo: {
    background: '#0B79D0',
  },
  chipSuccess: {
    background: '#3B873E',
    marginRight: theme.spacing(1),
  },
}))
